import React, { useState, useEffect } from 'react';

const EmailFrequencySelector = ({ maintenanceFrequency, setMaintenanceFrequency }) => {
  const [selectedFrequency, setSelectedFrequency] = useState(maintenanceFrequency || "now");
  const [validationMessage, setValidationMessage] = useState(null);

  const handleChange = (event) => setSelectedFrequency(event.target.value);

  const handleValidation = () => {
    setMaintenanceFrequency(selectedFrequency);
    localStorage.setItem("maintenanceFrequency", selectedFrequency);
    setValidationMessage("Fréquence d'envoi mise à jour !");
  };

  useEffect(() => {
    if (validationMessage) {
      const timer = setTimeout(() => setValidationMessage(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [validationMessage]);

  return (
    <div>
      <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold mb-3">Fréquence d'e-mails</p>
      <select
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        value={selectedFrequency}
        onChange={handleChange}
      >
        <option value="now">Maintenant</option>
        <option value="daily">Tous les jours</option>
        <option value="weekly">Toutes les semaines</option>
        <option value="biweekly">Toutes les deux semaines</option>
        <option value="monthly">Tous les mois</option>
      </select>
      <button
        className="mt-3 w-full bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold py-2.5 rounded-xl transition-all duration-200 cursor-pointer"
        onClick={handleValidation}
      >
        Valider
      </button>
      {validationMessage && (
        <div className="mt-3 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-xl px-3 py-2 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-emerald-500 shrink-0" />
          {validationMessage}
        </div>
      )}
    </div>
  );
};

export default EmailFrequencySelector;